import React, {useEffect, useRef, useState} from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import PaymentForm from './PaymentForm';
import Alert from '@mui/material/Alert';

const stripePromise = loadStripe(
    'pk_live_emyiy54wbScOj3qaLwnRtojL'
);

const API_BASE = process.env.REACT_APP_API_LOCAL_URL;

const CheckoutPage = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const quote = location.state?.quote;
    const formData = location.state?.formData;

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [bookingResponse, setBookingResponse] = useState(null);

    const [step, setStep] = useState('payment');

    useEffect(() => {
        if (!quote) {
            navigate('/cart');
        }
    }, [quote, navigate]);
    useEffect(() => {
        if (bookingResponse) {
            navigate('/booking-confirmed', {
                replace: true,
                state: { bookingResponse }
            });
        }
    }, [bookingResponse, navigate]);

    useEffect(() => {
        if (step === 'payment') {
            window.dataLayer.push({
                event: 'checkout_step_payment'
            });
        }
    }, [step]);
    if (!quote) return null;

    // ----------------------------
    // CUSTOMER FROM BOOKING FIELDS
    // ----------------------------
    const getCustomer = () => {
        const bf = formData?.bookingFields || {};

        return {
            firstName: bf['First Name'] || '',
            lastName: bf['Last Name'] || '',
            email: bf['Email'] || '',
            phone: bf['Phone'] || bf['Mobile'] || ''
        };
    };

    const customer = getCustomer();

    // ----------------------------
    // CREATE BOOKING
    // ----------------------------
    const createBooking = async (paymentMethodId) => {
        setLoading(true);
        setError('');

        try {
            const cartItems = JSON.parse(
                localStorage.getItem('booking_cart') || '[]'
            );

            const cleanedItems = cartItems.map(({ fields, ...rest }) => rest);


            const formattedBookingFields = Object.entries(
                formData.bookingFields || {}
            )
                .filter(([_, value]) => value && value.toString().trim() !== '')
                .map(([label, value]) => ({
                    label,
                    value: value.toString()
                }));

            const payload = {
                fields: formattedBookingFields,
                items: cleanedItems.map(item => ({
                    ...item,
                    pickupLocation: {locationName : formData.pickup[item.productCode] || null}
                })),

                coupon: location.state?.couponCode,

                customer: {
                    firstName: customer.firstName,
                    lastName: customer.lastName,
                    email: customer.email,
                    phone: customer.phone
                },

                resellerReference: `MYWEBSITE-${Date.now()}`,
                sendNotifications: true,
                status: "PENDING_SUPPLIER",
                paymentMethodId
            };

            const res = await axios.post(
                `${API_BASE}booking`,
                payload
            );

            if (res.data.success) {
                setBookingResponse(
                    res.data.data.api_response.booking
                );

                localStorage.removeItem('booking_cart');

                window.dispatchEvent(
                    new Event('cartUpdated')
                );
            } else {
                setError(res.data.message);
            }

        } catch (err) {
            setError(
                err.response?.data?.message ||
                'Booking failed'
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: 30, maxWidth: 600, margin: '0 auto' }}>

            {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {error}
                </Alert>
            )}

            {/* STEP payment: PAYMENT ONLY */}
            {step === 'payment' && (
                <>
                    <div style={{ marginBottom: 16 }}>
                        <button
                            onClick={() => navigate('/cart')}
                            style={{
                                background: 'transparent',
                                border: '1px solid #ccc',
                                padding: '8px 12px',
                                borderRadius: 6,
                                cursor: 'pointer'
                            }}
                        >
                            ← 戻る
                        </button>
                    </div>

                    <Elements stripe={stripePromise}>
                        <PaymentForm
                            email={customer.email}
                            name={`${customer.firstName} ${customer.lastName}`}
                            onSuccess={createBooking}
                        />
                    </Elements>
                </>
            )}
        </div>
    );
};

export default CheckoutPage;